module.exports = __webpack_public_path__ + "img/warn.127510a7.svg";